import React from 'react'
import './NavigationDots.scss'

interface INavigationDots {
  active: string
}

const NavigationDots = ({ active }: INavigationDots) => {
  return (
    <div className="app__navigation">
       {['home', 'about', 'work', 'skills', 'contact'].map((item, index) => (
          <a
            href={`#${item}`}
            key={item + index}
            className={`app__navigation-dot ${active === item ? "app__navigation-dot-active" : "" }` }
          />
        ))}
    </div>
  )
}

export default NavigationDots